<template>
  <div :class="classes.carouselNavigationWrapper">
    <ReturnArrow v-if="this.return" :color="iconColor" width="11" height="12" />
    <Arrow v-else :color="iconColor" width="7" height="13" />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import {
  ButtonStyle,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { defineComponent, computed } from "vue";
import Arrow from "../icons/Arrow.vue";
import ReturnArrow from "../icons/ReturnArrow.vue";

export default defineComponent({
  name: "CarouselNavigation",
  components: { Arrow, ReturnArrow },
  props: {
    buttonId: {
      type: String,
      required: false
    },
    direction: {
      type: String,
      required: true
    },
    return: {
      type: Boolean
    }
  },
  setup(props) {
    const { getButtonStyle } = injectBrand();
    const buttonStyle = computed(() => getButtonStyle(props.buttonId));

    const styleComputed = computed(() => ({
      buttonStyle: buttonStyle.value,
      direction: props.direction
    }));

    const iconColor = computed(() => buttonStyle.value?.iconColor);

    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const { classes } = useStyles(styleComputed);

    return {
      classes,
      iconColor,
      testClassName: computed(() => "text-style-market-name")
    };
  }
});

const defaultStyling = {
  backgroundColor: "#fff",
  borderRadius: "30px",
  borderColor: "#000",
  borderStyle: "solid",
  borderWidth: "1px",
  autoInteractions: true
};

const { useStyles } = createUseStyles<
  "carouselNavigationWrapper",
  {
    buttonStyle: ButtonStyle;
    direction: string;
  }
>({
  carouselNavigationWrapper: {
    backgroundColor: props =>
      props.buttonStyle.backgroundColor || defaultStyling.backgroundColor,
    borderColor: props =>
      props.buttonStyle.borderColor || defaultStyling.borderColor,
    borderStyle: props =>
      props.buttonStyle.borderStyle || defaultStyling.borderStyle,
    borderWidth: props =>
      props.buttonStyle.borderWidth || defaultStyling.borderWidth,
    transform: props =>
      `rotate(${props.direction === "previous" ? "180deg" : "0deg"})`,
    width: "30px",
    height: "40px",
    textAlign: "center",
    lineHeight: "7px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    cursor: "pointer",
    borderBottomLeftRadius: props => {
      if (props.buttonStyle.borderRadius === 0) {
        return 0;
      }
      return props.buttonStyle.borderRadius || defaultStyling.borderRadius;
    },
    borderTopLeftRadius: props => {
      if (props.buttonStyle.borderRadius == 0) {
        return 0;
      }
      return props.buttonStyle.borderRadius || defaultStyling.borderRadius;
    },
    borderBottomRightRadius: "0px !important",
    borderTopRightRadius: "0px !important",
    "&:hover": {
      backgroundColor: props => props.buttonStyle.actions.hover.backgroundColor
    },
    "&:active": {
      backgroundColor: props => props.buttonStyle.actions.active.backgroundColor
    }
  }
});
</script>
